export default {
  login: {
    title: 'Giriş',
    usernameLabel: 'Kullanıcı adı',
    usernamePlaceholder: '2-10 İngilizce rakam',
    loginPasswordLabel: 'Giriş şifresi',
    loginPasswordPlaceholder: 'Lütfen giriş şifrenizi giriniz',
    googleCodeLabel: 'Google doğrulama kodu',
    googleCodePlaceholder: 'Lütfen 6 basamaklı bir Google doğrulama kodu girin',
    hasNoAccount: 'Henüz hesap yok',
    goRegister: 'Kaydolmak için gidin',
    onlineCustom: 'Çevrimiçi müşteri hizmetleri',
    loginArgument: 'Giriş yapmaya devam etmek, kabul etmek anlamına gelir',
    userArgument: '《Kullanıcı Sözleşmesi》',
    registerNotEnabled: 'Kayıt fonksiyonu açık değil, lütfen yönetici ile iletişime geçin',
    usernameRequired: 'Lütfen doğru bir kullanıcı adı giriniz',
    loginPasswordRequired: 'Lütfen doğru giriş şifresini giriniz',
    googleCodeRequired: 'Lütfen doğru Google doğrulama kodunu girin',
    loginButton: 'giriş yap'
  },
  register: {
    title: 'Kaydol',
    usernameLabel: 'Kullanıcı adı',
    usernamePlaceholder: 'Lütfen kayıtlı kullanıcı adını girin',
    loginPasswordLabel: 'Giriş şifresi',
    loginPasswordPlaceholder: 'Lütfen kayıtlı kullanıcının oturum açma şifresini girin',
    loginPasswordPreLabel: 'Giriş şifresini onaylayın',
    loginPasswordPrePlaceholder: 'Lütfen giriş şifresini tekrar girin',
    fudPasswordLabel: 'Fon şifresi',
    fudPasswordPlaceholder: 'Lütfen fon şifresini giriniz',
    inviteCodeLabel: 'Davetiye Kodu',
    inviteCodePlaceholder: 'Lütfen 6 haneli bir davet kodu giriniz',
    registerNeed: 'Kayıt olmaya devam etmek, kabul etmek anlamına gelir',
    registerArgument: '《Kayıt Sözleşmesi》',
    usernameRequired: 'Lütfen doğru bir kullanıcı adı giriniz',
    loginPasswordRequired: 'Lütfen doğru giriş şifresini giriniz',
    loginPasswordPreRequired: 'Lütfen doğru onay giriş şifresini girin',
    fundPasswordRequired: 'Lütfen doğru fon şifresini giriniz',
    inviteCodeRequired: 'Lütfen doğru davet kodunu giriniz',
    diffLoginPasswordError: 'İki giriş şifresi tutarsız',
    registerSuccess: 'Başarılı kayıt',
    registerButton: 'Kaydol',
    emailLabel: 'E-posta',
    emailPlaceholder: 'Lütfen e-posta adresinizi giriniz',
    emailCodeLabel: 'Doğrulama kodu',
    emailCodePlaceholder: 'Lütfen e-posta doğrulama kodunuzu girin',
    second: 'ikinci',
    getEmailCodeButton: 'Kodu al',
    emailRequired: 'Lütfen doğru bir e-posta adresi girin ve tekrar deneyin',
    emailCodeRequired: 'Lütfen doğru e-posta doğrulama kodunu girin ve tekrar deneyin'
  },
  home: {
    hotCoin: {
      title: 'Tawaran hebat',
      more: 'fazla'
    },
    poster: {
      title: 'Hızlı para yatırma',
      enter: 'Şimdi Girin >',
      subTitle: 'BTC, USDT, ETH vb.\'yi destekleyin'
    },
    quickMenus: {
      futuresTrading: 'Vadeli İşlemler',
      helpCenter: 'Yardım Merkezi'
    },
    ranking: {
      increase: {
        title: 'Yükselen liste'
      },
      clinch: {
        title: 'Ciro Listesi'
      }
    }
  },
  tabBar: {
    home: 'ev',
    price: 'Pazar',
    trade: 'Ticaret',
    fund: 'Varlık',
    user: 'profili'
  },
  currency: {
    favorite: 'İsteğe bağlı',
    allCurrency: 'Nokta',
    dayVol: '24H',
    addFavor: '+ İyilik Ekle'
  },
  trade: {
    bills: 'Faturalar',
    todayOpen: 'Açık',
    star: 'Yıldız',
    vol: 'Hacim',
    low: 'En düşük',
    high: 'En yüksek',
    timing: 'hızlı',
    spot: 'vadeli işlemler',
    buyMore: 'Daha Fazla Satın Al',
    buyEmpty: 'Boş Satın Al',
    indicator: 'Gösterge',
    indicatorSettings: 'Gösterge Ayarları',
    balance: 'Bakiyem',
    fee: 'Hizmet ücreti',
    ruleIdError: 'Lütfen bir süre sonu seçin',
    deleteFavoriteSuccess: 'Favori para birimini başarıyla sil',
    addFavoriteSuccess: 'Favori para birimi başarıyla eklendi',
    buyIn: 'satın al',
    sellOut: 'Sat',
    holding: 'tutma pozisyonu',
    history: 'Geçmiş',
    spotOrderConfirm: {
      title: 'Satın Almayı Onayla',
      amountPlaceholder: 'Lütfen satın alma miktarını girin'
    },
    spotTradeOrder: {
      holding: {
        coin: 'para birimi',
        buyInAmountPrice: 'Alış Miktarı/Fiyatı',
        buyInCount: 'Miktar',
        actions: 'İşlem',
        sellOut: 'Sat',
        profit: '盈亏'
      }
    },
    orderConfirm: {
      title: 'Sipariş Onayı',
      coinName: 'Para',
      direction: 'Yön',
      price: 'Fiyat',
      balance: 'Bakiye',
      fee: 'Hizmet Bedeli',
      buyMoreLabel: 'Daha Fazla Satın Al',
      buyEmptyLabel: 'Boş Satın Al',
      buyQuantity: 'Miktar satın al',
      buyAmount: 'Satın Alma Tutarı',
      submit: 'Siparişi onayla'
    },
    kline: {
      open: 'Aç:',
      close: 'Kapat:',
      change: 'Değiştir:'
    }
  },
  finance: {
    title: 'Finans'
  },
  allFinance: {
    title: 'Finansal yönetim',
    all: 'hepsi'
  },
  financeOrders: {
    title: 'Taahhüt emri',
    holdingLabel: 'tutma',
    historyLabel: 'Geçmiş',
    holding: {
      amount: 'Taahhüt tutarı',
      rateStr: 'gelir miktarı/verim',
      vcCount: 'Rehin verilen coin sayısı',
      cycle: 'Konum döngüsü',
      day: 'gün',
      calcStartDate: 'Başlangıç ​​değeri tarihi',
      serviceAmount: 'Hizmet Ücreti',
      redeemOrder: 'Kullan'
    },
    history: {
      incomeAmount: 'gelir miktarı',
      rateStr: 'verim',
      amount: 'Taahhüt tutarı',
      vcCount: 'Rehin verilen coin sayısı',
      calcStartDate: 'Başlangıç ​​değeri tarihi',
      calcEndDate: 'Bitiş Tarihi',
      cycle: 'döngü günleri',
      serviceAmount: 'Hizmet Ücreti',
      day: 'gün'
    }
  },
  financeOrderBills: {
    title: 'Rehin gelir faturası',
    amount: 'miktar',
    balance: 'Denge'
  },
  financeItem: {
    rateStr: 'verim',
    buyType: 'Satın Alma Türü',
    cycle: 'döngü günleri',
    exchangeRate: 'Döviz kuru (sanal döviz kuru bakiyesi)',
    day: 'gün',
    cycleType: 'döngü türü',
    serviceRateStr: 'Hizmet Ücreti'
  },
  buyFinance: {
    title: 'Satın al',
    rateStr: 'verim',
    name: 'İsim',
    buyType: 'Satın Alma Türü',
    cycle: 'döngü günleri',
    cycleType: 'döngü türü',
    exchangeRate: 'Döviz kuru (sanal döviz kuru bakiyesi)',
    serviceRateStr: 'Hizmet Oranı',
    remark: 'yorum',
    buyAmountLabel: 'Satın Alma Miktarı ({coin})',
    descriptionTitle: 'Ürün Açıklaması',
    descriptionPart1: '1. Bu ürün anapara garantisi olmayan bir servet yönetimi ürünüdür. Piyasa dalgalanmaları anapara kayıplarına neden olabilir. Lütfen dikkatli yatırım yapın.',
    descriptionPart2: '2. Ödeme düzenleme kuralları:',
    descriptionPart3: 'Uzlaşma fiyatı < bağlantılı fiyat ise, BTC vade sonunda kapatılacaktır; takas tutarı = yatırım tutarı * (1+ gün * yıllık getiri oranı / 365).',
    descriptionPart4: 'Uzlaşma fiyatı sabit fiyat ≥ ise, USDT vade sonunda kapatılacaktır; takas tutarı = yatırım tutarı * sabit fiyat * (1+ gün * yıllık getiri oranı / 365).',
    descriptionPart5: '3. Gerçek yıllık getiri oranı piyasa ile gerçek zamanlı olarak değişir, lütfen gerçek satın alma işlemine bakın.',
    descriptionPart6: '4. Yatırım tutarı gerçek zamanlı olarak piyasaya göre dönüştürülür, lütfen gerçek satın alma işlemine bakın.',
    descriptionPart7: '5. Ürün satın alındıktan sonra para tutma sayfamda görüntülenebilir ve son kullanma tarihinden sonra para iadesi otomatik olarak spot hesaba yapılır.',
    buyButton: '[{coin}] satın al'
  },

  fund: {
    description: 'Varlıklar',
    recharge: 'Yeniden doldurma',
    withdraw: 'Çekilme',
    exchange: 'Transfer',
    empty: 'Cüzdan boş, git'
  },
  userCenter: {
    lastLogin: 'Son giriş',
    myTeam: 'Ekibim',
    identity: 'Doğrulama',
    walletAddress: 'Cüzdan adresi',
    zskAccount: 'ZSK Hesabı',
    bankCard: 'Banka hesabı',
    userBills: 'Kullanıcı Faturaları',
    timingTradeOrder: 'Ticaret Emrini Zamanlama',
    spotTradeOrder: 'vadeli pozisyonlar',
    contactTradeOrder: 'Sözleşme pozisyonu',
    userReport: 'Kullanıcı Raporu',
    teamReport: 'Ekip raporu',
    share: 'Paylaş',
    customer: 'Müşteri hizmetleri',
    helpCenter: 'Yardım Merkezi',
    platform: 'Platform Tanıtımı',
    profit: 'Kar',
    balance: 'Bakiye',
    withdraw: 'Çekilme',
    recharge: 'Yeniden doldurma',
    creditStoreLabel: 'Kredi Deposu'
  },
  settings: {
    title: 'Ayarlar',
    fundPassword: 'Fon şifresi',
    googleValidator: 'Google Doğrulayıcı',
    editLoginPassword: 'Giriş Şifresini Düzenle',
    switchLocale: 'Dili değiştir'
  },
  editFundPassword: {
    title: 'Fon Şifresini Değiştir',
    currentPasswordLabel: 'geçerli parola',
    currentPasswordPlaceholder: 'Lütfen mevcut fon şifresini giriniz',
    newPasswordLabel: 'Yeni Şifre',
    newPasswordPlaceholder: 'Lütfen değiştirilen fon şifresini giriniz',
    prePasswordLabel: 'Şifreyi onayla',
    prePasswordPlaceholder: 'Değiştirilen fon şifresini silin ve tekrar girin',
    tips: 'Fon şifresi işlemler için önemli bir sertifikadır, lütfen dikkatlice ayarlayın ve aklınızda bulundurun',
    currentPasswordRequired: 'Lütfen mevcut fon şifresini giriniz',
    newPasswordRequired: 'Değiştirilecek fon şifresini giriniz',
    prePasswordRequired: 'Değiştirilecek fon şifresini tekrar giriniz',
    prePasswordDiff: 'İki parola girişi tutarsız'
  },
  bindFundPassword: {
    title: 'Bağlama fonu şifresi',
    fundPasswordLabel: 'Fon Şifresi',
    fundPasswordPlaceholder: 'Lütfen fon şifresini girin',
    fundPasswordPreLabel: 'Şifreyi Onayla',
    fundPasswordPrePlaceholder: 'Lütfen fon şifresini tekrar girin',
    fundPasswordRequired: 'Fon şifresi gerekli',
    fundPasswordPreRequired: 'Parolayı onaylayın gerekli',
    fundPasswordDiff: 'İki şifre girişi tutarsız',
    bindSuccess: 'Bağlama Başarısı',
    tips: 'Fon şifresi işlemler için önemli bir sertifikadır, lütfen dikkatli bir şekilde ayarlayın ve aklınızda bulundurun'
  },
  editLoginPassword: {
    title: 'Giriş şifresini değiştir',
    currentPasswordLabel: 'Mevcut şifre',
    currentPasswordPlaceholder: 'Lütfen geçerli oturum açma parolasını girin',
    newPasswordLabel: 'Yeni Şifre',
    newPasswordPlaceholder: 'Lütfen değiştirilen giriş şifresini girin',
    prePasswordLabel: 'Şifreyi onayla',
    prePasswordPlaceholder: 'Değiştirilen oturum açma parolasını temizleyin ve yeniden girin',
    tips: 'Oturum açma parolası, oturum açma kimlik doğrulaması vb. için önemli bir kimlik bilgisidir, lütfen dikkatli bir şekilde ayarlayın ve aklınızda bulundurun',
    currentPasswordRequired: 'Lütfen geçerli oturum açma parolasını girin',
    newPasswordRequired: 'Lütfen değiştirilecek giriş şifresini giriniz',
    prePasswordRequired: 'Lütfen değiştirilecek giriş şifresini tekrar girin',
    prePasswordDiff: 'İki parola girişi tutarsız'
  },
  bindGoogleValidator: {
    title: 'Google Authenticator\'ı Bağla',
    qrCodeLabel: 'QR kodu',
    keyLabel: 'Anahtar',
    loginPasswordLabel: 'Giriş şifresi',
    loginPasswordPlaceholder: 'Lütfen giriş şifrenizi giriniz',
    googleCodeLabel: 'Google doğrulama kodu',
    googleCodePlaceholder: 'Lütfen 6 basamaklı bir Google doğrulama kodu girin',
    tipsPart1: 'Google Authenticator\'ı uygulama mağazasında arayın',
    tipPart2: 'Yukarıdaki QR kodunu taramak için Google Authenticator\'ı kullanın veya bağlama için anahtarı manuel olarak girin',
    tipPart3: 'Yukarıdaki 6 haneli Google doğrulama kodunu girin, göndermek için Onayla\'yı tıklayın',
    loginPasswordRequired: 'Lütfen oturum açma şifresini giriniz',
    googleCodeRequired: 'Lütfen 6 basamaklı bir Google doğrulama kodu girin'
  },
  walletAddress: {
    title: 'Cüzdan Adresi',
    add: '+ Adres Ekle',
    remark: 'Açıklama',
    addButton: 'Cüzdan adresi ekle',
    tips: 'Adres bilgilerini değiştirmek veya silmek isterseniz, lütfen müşteri hizmetleri ile iletişime geçin'
  },
  addWalletAddress: {
    title: 'Cüzdan adresi ekle',
    vcChainNameIdLabel: 'Zincir tipi',
    vcAccountLabel: 'Cüzdan adresi',
    vcAccountPlaceholder: 'Lütfen cüzdan adresini girin',
    commentLabel: 'Açıklamalar',
    commentPlaceholder: 'Lütfen açıklama içeriğini girin',
    fundPasswordLabel: 'Fon Şifresi',
    fundPasswordPlaceholder: 'Lütfen fon şifrenizi giriniz',
    tips: 'Eklenen cüzdan adresi değiştirilemez, lütfen bilgilerin doğru olduğunu doğrulayın',
    vcIdRequired: 'Lütfen doğru para birimini seçin',
    vcChainNameIdRequired: 'Lütfen doğru zincir tipini seçin',
    vcAccountRequired: 'Lütfen doğru cüzdan adresini giriniz',
    fundPwdRequired: 'Lütfen doğru fon şifresini giriniz',
    addSuccess: 'Cüzdan adresi başarıyla eklendi'
  },
  receiveWays: {
    title: 'Banka Kartım',
    add: '+ Banka kartı ekle',
    tips: 'Banka kartı bilgilerini değiştirmek veya silmek isterseniz, lütfen müşteri hizmetleri ile iletişime geçin',
    addCardButton: 'Banka kartı ekle'
  },
  zskAccount: {
    title: 'Hızlı hesap',
    add: '+ Hızlı hesap ekle',
    tips: 'Hesap bilgilerini değiştirmek veya silmek için lütfen müşteri hizmetleri ile iletişime geçin',
    addCardButton: 'Hesap ekle'
  },
  addZskAccount: {
    title: 'Hızlı hesap ekle',
    withdrawNameLabel: 'Ad',
    withdrawNamePlaceholder: 'Lütfen adı giriniz',
    withdrawNameRequired: 'İsim gereklidir',
    zskLabel: 'ZSK',
    zskPlaceholder: 'Lütfen hızlı hız kimliğini girin',
    fundPasswordLabel: 'Fon parolası',
    fundPasswordPlaceholder: 'Lütfen fon şifrenizi giriniz',
    tips: 'Lütfen eklenen hesabın bilgilerini dikkatli bir şekilde doldurun, yanlış bilgi nedeniyle para çekme işleminin gerçekleşmemesinden şirket sorumlu olmayacaktır'
  },
  addBankCard: {
    title: 'Yeni bir banka kartı ekle',
    withdrawNameLabel: 'Ad',
    withdrawNamePlaceholder: 'Lütfen adı giriniz',
    withdrawNameRequired: 'İsim gereklidir',
    zskLabel: 'ZSK',
    zskPlaceholder: 'Lütfen ZSK kimliğini girin',
    zskRequired: 'ZSK kimliği gerekli',
    cardNumLabel: 'Banka hesap numarası',
    cardNumPlaceholder: 'Lütfen banka kartı numarasını giriniz',
    branchLabel: 'Şube adresi',
    branchPlaceholder: 'Lütfen banka kartı şube adresini giriniz',
    fundPasswordLabel: 'Fon parolası',
    fundPasswordPlaceholder: 'Lütfen fon şifresini giriniz',
    tips: 'Banka kartı nakit çekme işlemi için önemli bir veridir, lütfen dikkatli bir şekilde doldurun, kart bilgilerinin yanlış doldurulması nedeniyle nakit alınamaması gibi sorunlardan şirket sorumlu olmayacaktır. ',
    backIdRequired: 'Lütfen hesap bankasını seçin',
    cardNumRequired: 'Lütfen doğru banka kartı numarasını giriniz',
    fundPwdRequired: 'Lütfen doğru fon şifresini girin',
    idCardPlaceholder: 'Lütfen kimlik numaranızı giriniz',
    idCardLabel: 'Kimlik kartı numarası',
    idCardRequired: 'Lütfen doğru kimlik numarasını girin',
    cciPlaceholder: 'Lütfen banka kartını girin CCI',
    branchCodePlaceholder: 'Lütfen şube kodunu giriniz',
    branchCodeLabel: 'Şube Kodu',
    katakanaPlaceholder: 'Lütfen katakana\'yı girin',
    katakanaLabel: 'Katakana'
  },
  userBills: {
    title: 'Hesap Değişikliği Kaydı',
    vcName: 'Para Birimi',
    amount: 'Miktar',
    balance: 'Bakiye'
  },
  timingTradeOrder: {
    title: 'Ticaret emrini zamanlama',
    waiting: {
      title: 'Siparişler devam ediyor',
      amount: 'Tutar',
      period: 'dönem',
      receivePrice: 'Alış fiyatı',
      settlement: 'uzlaşma devam ediyor'
    },
    history: {
      title: 'Tarihsel Emirler',
      buyInClose: 'Alış fiyatı',
      saleOutClose: 'indirimli fiyat'
    }
  },
  spotTradeOrder: {
    title: 'Perintah Dagangan Niaga Hadapan',
    waiting: {
      title: 'Pesanan sedang berjalan',
      buyInAmount: 'jumlah harga belian',
      buyInPrice: 'Beli harga seunit',
      buyInCount: 'Kuantiti Beli',
      buyInTime: 'beli masa'
    },
    history: {
      title: 'Perintah Sejarah',
      buyInAmount: 'jumlah harga belian',
      buyInPrice: 'Beli harga seunit',
      buyInCount: 'Kuantiti Beli',
      sellOutAmount: 'Jumlah harga jualan',
      sellOutPrice: 'Jual harga seunit',
      sellOutTime: 'masa jual'
    }
  },
  userReport: {
    title: 'Kullanıcı Raporu',
    profit: 'Kar',
    timingTradeAmountFee: 'Son derece hızlı işlem emri/işlem ücreti',
    timingTradePrizePoint: 'Son derece hızlı işlem bonusu/indirimi',
    rechargeInfo: 'Şarj/taşıma ücreti',
    withdrawInfo: 'Para çekme/işlem ücreti',
    exchangeInfo: 'Değişim/işlem ücreti'
  },
  userReportDay: {
    title: 'Kullanıcı Günlük Raporu',
    profit: 'Kar',
    timingTradeAmountFee: 'Son derece hızlı işlem emri/işlem ücreti',
    timingTradePrizePoint: 'Son derece hızlı işlem bonusu/indirimi',
    rechargeInfo: 'Şarj/taşıma ücreti',
    withdrawInfo: 'Para çekme/işlem ücreti',
    exchangeInfo: 'Değişim/işlem ücreti'
  },
  teamReport: {
    goToReportDay: 'Rapor Günü',
    timingTradeBetAmountServiceCharge: 'Ticaret Miktarını/Hizmetlerini Zamanlama',
    timingTradeBetPrizePoint: 'Zamanlama Ticaret Ödülü/Puan',
    timingTradeUserAndCount: 'Ticaret Kullanıcılarını/Sayılarını Zamanlama',
    rechargeAmountFee: 'Yükleme Miktarı/Hizmetleri',
    rechargePersonCount: 'Kullanıcıları/Sayıları Yeniden Yükle',
    withdrawAmountFee: 'Çekme Miktarı/Hizmetleri',
    withdrawPersonCount: 'Kullanıcıları/Sayıları Geri Çek',
    firstRechargeUserAndCount: 'İlk Şarj Miktarı/Sayıları',
    title: 'Ekip Raporu',
    usernamePlaceholder: 'Alt düzey kullanıcı adını girin',
    previewAllTradeInfo: 'Tüm hızlı ticaret bilgilerini görüntüle',
    coin: 'para birimi',
    timingTradeBetAmount: 'Son derece hızlı ticaret bahis miktarı',
    profit: 'Kar',
    action: 'işlem',
    previewReportDay: 'Günlük raporu görüntüle'
  },
  teamTimingTradeInfo: {
    title: 'Takım Hızı Ticareti',
    profit: 'Kar',
    subTitle: 'Ekip hızı işlem bilgisi',
    timingTradeAmountFee: 'Son derece hızlı işlem emri/hizmet ücreti',
    timingTradePrizePoint: 'Son derece hızlı işlem bonusu/indirimi',
    rechargeInfo: 'Şarj/Hizmet Ücreti',
    withdrawInfo: 'Para Çekme/Hizmet Ücreti',
    exchangeInfo: 'Değişim/Hizmet Ücreti'
  },
  teamReportDay: {
    title: 'Ekip Günlük Raporu',
    subTitle: 'Ekip [ {username} ] Günlük Raporu',
    timingTradeBetAmountFee: 'Son derece hızlı işlem emri/hizmet ücreti',
    timingTradeUserAndCount: 'Ticaret Kullanıcılarını/Sayılarını Zamanlama',
    timingTradeBetPrizePoint: 'Hızlı İşlem Bonusu/İndirimi',
    rechargeAmountFee: 'Şarj miktarı/hizmet ücreti',
    rechargePersonCount: 'Kişiyi/işlem sayısını yeniden şarj et',
    firstRechargePersonCount: 'İlk Şarj Miktarı/Sayıları',
    drawAmountFee: 'Çekilen miktar/hizmet ücreti',
    drawPersonCount: 'Para/işlem çeken kişi sayısı',
    exchangeAmountFee: 'Değişim Tutarı/Hizmet Ücreti'
  },
  share: {
    title: 'Paylaş',
    qrCodeLabel: 'QR kodu',
    registerUrlLabel: 'Kayıt adresi',
    inviteCodeLabel: 'Davetiye Kodu',
    hasNoInviteCode: 'Cari hesabın davet kodu yok',
    buildInvitationCode: 'Tek tıkla oluşturmayı dene',
    tipPart1: 'Kayıt olmak için kayıt bilgilerini doldurmak için yukarıdaki QR kodunu tarayın',
    tipPart2: 'Kayıt adresini kopyalayın ve kayıt olmak için kayıt bilgilerini doldurun',
    tipPart3: 'Kayıt olmak için bu sitenin kayıt arayüzünü manuel olarak açın ve davet kodunu girin',
    saveImageError: 'Resim kaydedilemedi, resme uzun basıp kaydetmeyi deneyin'
  },
  myTeam: {
    title: 'Ekibim',
    usernamePlaceholder: 'Alt düzey kullanıcı adını girin',
    point: 'indirim (hız/sözleşme)',
    totalBalance: 'Bakiye',
    lastLoginTime: 'Son Giriş Zamanı',
    noLoginTime: 'yok'
  },
  userDetail: {
    title: 'Kullanıcı Detayı',
    username: 'Kullanıcı adı',
    userType: 'Kullanıcı Türü',
    pointPercentTiming: 'Zamanlama Noktası',
    pointPercentContract: 'Sözleşme Noktası',
    registerWay: 'Kayıt yöntemi',
    teamCounts: 'Takım numarası',
    teamOnline: 'ekip çevrimiçi',
    balance: 'Denge',
    registerTime: 'Kayıt zamanı',
    onlineStatus: 'giriş durumu'
  },
  addUser: {
    title: 'Kullanıcı Ekle',
    addUserDirect: {
      userTypeLabel: 'Kullanıcı Türü',
      usernameLabel: 'Kullanıcı adı',
      usernamePlaceholder: 'Lütfen hesabın kullanıcı adını girin',
      pointTimingLabel: 'Son derece hızlı işlem indirimi',
      pointContractLabel: 'Sözleşme işlemi indirimi',
      tips: 'İlk şifre: "{şifre}"; lütfen hesabı açtıktan sonra kullanıcıya şifreyi zamanında değiştirmesini hatırlatın',
      userTypeRequired: 'Lütfen hesap türünü seçin',
      usernameRequired: 'Lütfen hesabın kullanıcı adını giriniz',
      pointTimingRequired: 'Lütfen hızlı işlem indirimini seçin',
      pointContractRequired: 'Lütfen sözleşme işlem indirimini seçin',
      copyTemplate: `
          Kullanıcı adı: {kullanıcı adı};
          Oturum açma şifresi: {loginPassword};
          Giriş URL'si: {loginAddress};
          Hızlı ticaret indirimi: {timingTradePoint};
          Sözleşme ticareti indirimi: {contactTradePoint};
          `
    }
  },
  recharge: {
    title: 'Şarj',
    configIdLabel: 'Kanalı şarj et',
    chainNameLabel: 'Zincir adı',
    amountLabel: 'Yatırılan Tutar',
    userCardNameLabel: 'Ödeyen',
    userCardNamePlaceholder: 'Lütfen ödeyenin adını girin',
    fee: 'hizmet ücreti',
    ReceiveAmountTipsPart1: 'Yükle',
    ReceiveAmountTipsPart2: ', Ödeme gerekiyor',
    tipsPart1: 'Çevrimiçi ödeme arayüzü kararsız olduğundan, şu anda yalnızca çevrimdışı aktarım ve yeniden ödeme destekleniyor! ',
    tipsPart2: 'Lütfen gerçek transfer tutarını doğru bir şekilde girin, aksi takdirde sistemin incelemede başarısız olmasına neden olabilir ve yeniden yükleme sürecini etkileyebilir. ',
    emptyPart1: 'Yükleme Kanalı Yok,',
    emptyPart2: 'Tekrar denemek için dokunun',
    amountRequired: 'Yükleme miktarı boş olamaz',
    maxPrecisionError: 'Yükleme miktarı en fazla {amountMaxPrecision} ondalık basamağa sahip olabilir',
    payUserNameError: 'Lütfen doğru bir ödeme yapan kişi girin ve tekrar deneyin',
    userMobileLabel: 'Mobil',
    userMobilePlaceholder: 'Lütfen cep telefonunuzu girin',
    needPayLabel: 'Ödeme Gerekiyor',
    needPayPlaceholder: 'Lütfen Tutarı Girin'
  },
  payDetail: {
    title: 'Bilgi Aktarımı',
    addressLabel: 'Para yatırma adresi',
    rechargeAmount: 'Miktar',
    bankNameLabel: 'Banka',
    branchLabel: 'Şube adresi',
    cardName: 'İsim',
    cardNum: 'kart numarası',
    uploadImgLabel: 'Ödeme Bilgileri',
    uploadImgPlaceholder: 'Ödeme fişi resmini yüklemek için tıklayın',
    uploadImgRequired: 'Lütfen ödeme çeki resmini yükleyin',
    vcTransferTipsPart1: '1. Para yatırma adresini kopyalayın veya para yatırmak için QR kodunu tarayın',
    vcTransferTipsPart2: '2. Para yatırma işlemi tamamlandıktan sonra ödeme makbuzu resmini yükleyin',
    vcTransferTipsPart3: 'Para yatırma verimliliğini artırmak için, lütfen net ve yüksek tanımlı bir sertifika resmi yüklediğinizden emin olun, ilgili bilgi resmi net değilse, sistemin incelemede başarısız olmasına ve yatırma işleminin ilerlemesini etkilemesine neden olabilir. ',
    bankCardTips: 'Para yatırma verimliliğini artırmak için lütfen havale edenin ve havale edenin adının aynı olduğundan emin olun; ilgili bilgilerin eşleşmemesi, sistemin incelemede başarısız olmasına neden olabilir ve para yatırma işleminin ilerlemesini etkileyebilir. ',
    bankCardTransferSuccess: 'Başarıyla transfer ettim'
  },
  rechargeOrder: {
    title: 'Para yatırma emri',
    payAmount: 'Tutar',
    receiveAmount: 'Alınan Tutar'
  },
  identity: {
    title: 'Gerçek ad bilgisi',
    subTitle: 'Gerçek ad kimlik doğrulaması, bilgi kimlik doğrulamasını, kimlik kimlik doğrulamasını içerir',
    name: 'İsim',
    idType: 'Belge türü',
    idNum: 'Kimlik numarası',
    demand: 'Gereksinim',
    informationVer: 'Bilgi Doğrulama',
    idAuthentication: 'Kimlik Doğrulama',
    material: 'Malzeme'
  },
  verified: {
    title: 'Doğrulandı',
    idCardTypeLabel: 'Sertifika türü',
    idCardFrontSideImgLabel: 'Card Front SideImgLabel',
    idCardBackSideImgLabel: 'Kimlik fotoğrafının arkası',
    idCardHandSideImgLabel: 'Elde kimlik fotoğrafı',
    nameLabel: 'Belge adı',
    namePlaceholder: 'Lütfen kimlik adınızı girin',
    idCardNumLabel: 'Kimlik kartı numarası',
    idCardNumPlaceholder: 'Lütfen kimlik numarasını giriniz',
    fundPwdLabel: 'Fon parolası',
    fundPwdPlaceholder: 'Lütfen fon şifrenizi giriniz',
    tips: 'Bilgi doğrulaması gönderildikten sonra değiştirilemez, lütfen dikkatlice kontrol edin ve doğru şekilde doldurun',
    idCardTypeRequired: 'Lütfen kart tipini seçiniz',
    idCardFrontSideImgRequired: 'Lütfen kimlik kartının önden fotoğrafını yükleyin',
    idCardBackSideImgRequired: 'Lütfen kimlik kartının arka yüzünün fotoğrafını yükleyiniz',
    idCardHandSideImgRequired: 'Lütfen elde tutulan bir kimlik fotoğrafı yükleyin',
    nameRequired: 'Lütfen belgenin adını giriniz',
    idCardNumRequired: 'Lütfen kimlik numarasını giriniz',
    fundPwdRequired: 'Lütfen fon şifrenizi giriniz',
    submitSuccess: 'Kimlik doğrulama isteği başarıyla gönderildi'
  },
  help: {
    title: 'Yardım Merkezi'
  },
  helpDetail: {
    title: 'Yardım Ayrıntıları'
  },
  myMessage: {
    title: 'Mesajım'
  },
  messageDetail: {
    title: 'Mesaj ayrıntıları'
  },
  withdraw: {
    title: 'Para çek',
    tips: 'Fonların güvenliğini ve para çekme işleminin etkinliğini sağlamak için; lütfen girilen bilgilerin doğruluğunu dikkatlice kontrol ediniz, para çekme işlemi sırasında oluşan hizmet bedeli bakiyeden düşülecektir',
    receiveAmountTipsPart1: 'Çek',
    receiveAmountTipsPart2: ', gelmesi bekleniyor',
    fee: 'Hizmet ücreti',
    myBalance: '[{vcName}] bakiyem:',
    configIdLabel: 'Para çekme kanalı',
    amountLabel: 'Çekilme tutarı',
    fundLabel: 'Fon şifresi',
    fundPlaceholder: 'Lütfen fon şifrenizi giriniz',
    googleCodeLabel: 'Google doğrulama kodu',
    googleCodePlaceholder: 'Lütfen 6 basamaklı bir Google doğrulama kodu girin',
    maxPrecisionError: 'Para çekme miktarı en fazla {amountMaxPrecision} ondalık basamağa sahip olabilir',
    amountRequired: 'Lütfen doğru para çekme miktarını girin veya seçin',
    bankCardError: 'Lütfen doğru banka kartını seçin',
    fundPwdError: 'Lütfen doğru fon şifresini girin',
    walletAddressError: 'Lütfen doğru cüzdan adresini seçin',
    success: 'Para çekme talebi başarıyla gönderildi, lütfen işlenmesini bekleyin',
    emptyPart1: 'Kullanılabilir para çekme kanalı yok,',
    emptyPart2: 'Tekrar denemek için dokunun'
  },
  withdrawOrder: {
    title: 'Para çekme emri',
    requestAmount: 'Tutar',
    receiveAmount: 'Alınan Tutar'
  },
  locales: {
    title: 'Dili değiştir'
  },
  lines: {
    title: 'Çizgiler',
    switchLine: 'Hat Değiştir'
  },
  currencyPop: {
    deleteFavoriteSuccess: 'Favori para birimini başarıyla sil',
    addFavoriteSuccess: 'Favori para birimi başarıyla eklendi'
  },
  currencySelect: {
    currencyName: 'para birimi',
    currencyPlaceholder: 'Para birimini seçmek için tıklayın'
  },
  walletItem: {
    available: 'Müsait',
    convert: 'dönüştür (USDT)'
  },
  banks: {
    bankIdLabel: 'Banka',
    bankIdPlaceholder: 'Bir banka seçmek için tıklayın'
  },
  banksPop: {
    title: 'Banka Seç',
    search: 'Giriş bankası anahtar sözcükleri'
  },
  historyOrderDetail: {
    title: 'Sipariş Ayrıntıları',
    coin: 'İşlem para birimi',
    amount: 'sipariş tutarı',
    buyInClose: 'Alış fiyatı',
    sellOutClose: 'Satış fiyatı',
    isQuest: 'Bu siparişle ilgili sorunuz var mı?',
    connectCustomer: 'Müşteri hizmetleriyle iletişime geçilsin mi?'
  },
  pointSelect: {
    prizeGroupPlaceholder: 'Kullanıcı indirimini seçmek için tıklayın'
  },
  walletAddressSelect: {
    title: 'Cüzdan adresi seçin',
    label: 'Cüzdan adresi',
    placeholder: 'Cüzdan adresini seçmek için tıklayın'
  },
  myCardSelect: {
    title: 'Hesap seçin',
    label: 'alıcı hesap',
    placeholder: 'Bir hesap seçmek için tıklayın'
  },
  amountInput: {
    amountRange: 'Min {minAmount}, Maks {maxAmount}',
    amountMin: 'Min {minAmount}, Sınırsız',
    amountErrorEmpty: '{label} gerekli',
    amountErrorOutRange: '{label} aralığın dışında'
  },
  amountFormItem: {
    placeholderOnlyMin: 'Min {minAmount}, Sınırsız',
    placeholderHasMax: 'Min {minAmount}, Maks {maxAmount}',
    amountErrorEmpty: 'Miktar yanlış',
    amountErrorOutRange: 'Miktar aralığın dışında'
  },
  common: {
    remark: 'Açıklama',
    saveImage: 'Resmi Kaydet',
    online: 'Çevrimiçi',
    offline: 'Çevrimdışı',
    profit: 'Kar',
    date: 'Tarih',
    period: 'Dönem',
    pointAmount: 'Puan Tutarı',
    point: 'Kullanıcı indirimi',
    direction: 'Yön',
    winLoss: 'Gelir',
    lose: 'Kaybetmek',
    add: 'Ekle',
    win: 'Kazanmak',
    edit: 'Değiştir',
    notBind: 'İlişkisiz',
    alreadyBind: 'Zaten Bağlı',
    enabled: 'Etkin',
    notEnabled: 'NotEnabled',
    queryRange: 'Sorgu Aralığı',
    copy: 'Kopyala',
    orderNum: 'Sipariş',
    null: 'Sıfır',
    noData: 'Veri Yok',
    freshSuccess: 'Yenileme Başarısı',
    loadMoreData: 'Daha fazla veri yükle',
    noMoreData: 'Daha fazla veri yok',
    lookMore: 'Daha',
    more: 'Daha'
  },
  date: {
    today: 'Bugün',
    yesterday: 'Dün',
    last7Days: 'Yaklaşık 7 gün',
    last14Days: 'Yaklaşık 14 gün',
    split: 'Kime'
  },
  button: {
    save: 'Kaydet',
    logout: 'Çıkış',
    confirm: 'Tamam',
    cancel: 'İptal',
    submit: 'Gönder',
    addNow: 'Şimdi ekle',
    reset: 'sıfırla',
    nextStep: 'İleri',
    goCertification: 'Sertifikaya git'
  },
  confirm: {
    title: {
      logout: 'Çıkış',
      unBindFundPassword: 'Bağlantısız fon şifresi',
      addUserDirect: 'Kullanıcı Ekle',
      addUserInfo: 'Kullanıcı başarıyla eklendi',
      jumpToRechargePage: 'Atlamayı Onayla',
      unAuthentication: 'UnAuthentication',
      noBindBankCard: 'Banka kartı yok',
      noBindCoinAddress: 'Cüzdan adresi yok',
      tradeConfirm: 'İşlemi onaylayın',
      sellOutSpotOrder: 'satış pozisyonu',
      buyFinance: 'satın almayı onayla',
      redeemOrder: 'Taahhüt emri itfa'
    },
    content: {
      logout: 'Cari hesaptan çıkmak istediğinizden emin misiniz?',
      unBindFundPassword: 'Bağlantısız bir fon şifresi tespit edildi, hesap güvenliğini sağlamak için lütfen önce fon şifrenizi bağlayın',
      addUserDirect: 'Yakında yeni bir kullanıcı eklenecek, lütfen bilgilerin doğru olduğunu doğrulayın ve devam etmek için Tamam\'ı tıklayın, kullanıcı adı [ {username}], kullanıcı türü [ {userType} ], oturum açma şifresi [ {password}] ve hızlı ticaret indirimim [ {diffPointTiming} ] ile sözleşme işlemi indirimim arasındaki fark [ {diffPointContract} ]',
      addUserInfo: 'Kullanıcı adı [ {kullanıcıadı}]; <br /> Oturum açma parolası [ {password} ];<br /> Oturum Açma URL\'si [ {loginAddress} ];<br /> Aşırı işlem indirimi [ {pointPercentTiming} ];<br /> /> Sözleşme işlem indirimi [{pointPercentContract} ];',
      jumpToRechargePage: 'Üç taraf şarj arayüzüne atlamak üzere, devam etmek için lütfen onayla\'yı tıklayın',
      unAuthentication: 'Hesabın gerçek adla kimlik doğrulamasından geçmediği tespit edildi. Fonların normal dolaşımını sağlamak için lütfen önce gerçek adla kimlik doğrulaması yapın',
      noBindBankCard: 'Hesabın bir banka kartı ile bağlı olmadığı veya aktifleştirilmediği tespit edildi. Paranın normal dolaşımını sağlamak için lütfen önce banka kartını bağlayın',
      noBindCoinAddress: 'Hesabın bağlı veya etkin sanal para birimi hesabı olmadığı algılandı. Fonların normal dolaşımını sağlamak için lütfen önce sanal para hesap adresini ekleyin',
      tradeConfirm: 'Sipariş gönderilmek üzere, lütfen sipariş bilgilerinin doğru olduğunu onaylayın ve göndermek için Siparişi Onayla\'ya tıklayın',
      sellOutSpotOrder: 'Konum emri satılmak üzere, lütfen işlemin doğru olduğunu onaylayın ve devam etmek için Tamam\'ı tıklayın.',
      buyFinance: '[{coin}] satın almak üzere, hisse satın alın: {amount}, lütfen işlemin doğru olduğunu onaylayın ve devam etmek için Tamam\'ı tıklayın',
      redeemOrder: 'Katkı siparişi ({orderNum}) kullanılmak üzere, lütfen işlemin doğru olduğunu onaylayın ve devam etmek için Onayla\'yı tıklayın.'
    }
  },
  message: {
    bindSuccess: 'Bağlama başarılı',
    successOperation: 'İşlem başarılı oldu',
    logoutSuccess: 'Başarıyla çık',
    editSuccess: 'Başarıyla değiştirildi',
    addSuccess: 'Ekleme başarıyla',
    copySuccess: 'Kopyalama başarılı',
    copyFailed: 'Kopyalama başarısız oldu'
  },
  vux: {
    'inline-calendar': {
      week_day_0: 'Gün',
      week_day_1: 'Bir',
      week_day_2: 'iki',
      week_day_3: 'üç',
      week_day_4: 'dört',
      week_day_5: 'beş',
      week_day_6: 'Altı'
    },
    loading: {
      loading: 'yükleniyor'
    }
  },
  helpItems: {
    title: {
      part1: 'Varlıklarda dönüştürülen miktar neden değişiyor? ',
      part2: 'OTC işlemleri için fon şifresi işleme yönteminin unutulması',
      part3: 'OTC işlemi satın alma işlemi tamamlandıktan sonra fonlar nereye akacak? ',
      part4: 'Takma adınızı değiştirme sayısını neden sınırlamak istiyorsunuz',
      part5: 'Transferin anlamı nedir, neden transfer etmek gerekir',
      part6: 'Kullanıcı sözleşmesinin hesap öz sermayesi nasıl hesaplanır? ',
      part7: 'Açılış pozisyonunda belirlenen zararı durdur ve karı al\'ın değeri nedir? Nasıl ayarlanmalıdır? ',
      part8: 'Sözleşme riski nasıl azaltılır? ',
      part9: 'Sözleşme açık pozisyonundaki miktar neyi gösteriyor? ',
      part10: 'Zorla tasfiyeye ilişkin talimatlar',
      part11: 'Sözleşmeli ticaret kuralları nelerdir? ',
      part12: 'Sözleşmeli ticarette marj nedir? ',
      part13: 'Limit emri ve piyasa emri nedir? ',
      part14: 'Sözleşme işlemlerinin riski neyi temsil eder',
      part15: 'Neden para birimi dönüştürmeye ihtiyacınız var? ',
      part16: 'OTC işlem aktarımından sonra karşı taraf neden zamanında havaleyi almadı? ',
      part17: 'Tether (USDT) OTC aracılığıyla nasıl satın alınır? '
    },
    content: {
      part1: 'Şu anda Renminbi\'de tutulan dijital para biriminin varlığa dönüştürüldüğünde değeri, dijital varlıkların fiyat dalgalanmaları nedeniyle değişecektir. Dijital varlıklarınızın sayısı değişmedi. ',
      part2: 'OTC işlem fonu şifresini unutursanız, lütfen "Ayarlarım-Fon şifresini ayarlamak için tıklayın" bölümüne gidin veya sıfırlamak için müşteri hizmetleri ile iletişime geçin',
      part3: 'OTC satın alma emri tamamlandıktan sonra fonlar, varlıktaki yasal para birimi hesabına girecektir. Sözleşme ticareti veya vadeli işlem ticareti için OTC satın alınan varlıkları kullanmanız gerekiyorsa, transfer etmek için lütfen fon transferi modülüne gidin. ',
      part4: 'İşleminizin güvenlik nedeniyle, şu anda takma adı yalnızca bir kez değiştirilecek şekilde sınırlıyoruz. ',
      part5: 'Çeşitli hesaplarınız arasında fonların bağımsızlığını sağlamak ve makul risk kontrolünüzü kolaylaştırmak için, ana ticaret modüllerinin hesapları burada bölünmüştür. Transfer, varlıkların çeşitli ticaret hesapları arasında karşılıklı olarak dönüştürülmesi sürecini ifade eder. ',
      part6: '<p>Sözleşme hesabı özkaynağı, hesaplama yöntemi aşağıdaki gibidir:</p> <p>Sözleşme hesap özkaynağı = pozisyon marjı + pozisyon değişken kâr ve zarar + cari hesap kullanılabilir tutarı</p>',
      part7: 'Kar al ve zararı durdur, sizin tarafınızdan belirlenen kar limiti ve kayıp limitidir. Belirlenen zararı durdur ve zararı durdur tutarına ulaşıldığında, sistem otomatik olarak pozisyonu kapatacaktır. Sözleşme satın alırken risk kontrolünüz için kullanılabilir. Belirlenen kar alma tutarının yarısı şu şekildedir: artış miktarı x miktar x çoklu kaldıraç ve zararı durdurmayı ayarlayın. Riskleri makul bir şekilde kontrol etmek için bunu gerçek varlık durumunuza göre ayarlamanızı öneririz. ',
      part8: 'Kalan hesapların mevcut varlıklarını para transferi yaparak sözleşme hesabına aktarabilir veya pozisyonu düşürerek riski azaltabilirsiniz. ',
      part9: 'Açık pozisyondaki miktar, satın almayı beklediğiniz döviz miktarını gösterir. Örneğin: BTC/USDT ticaret çiftinin açılış sayfasında, uzun satın almayı seçin, fiyatı 1000USDT olarak girin ve miktarı 10BTC olarak girin, bunun anlamı: 1000USDT birim fiyatıyla 10 BTC almayı bekliyorsunuz. ',
      part10: '<p>Risk derecesi, varlıklarınızın riskini ölçmek için bir göstergedir. Risk derecesi %100\'e eşit olduğunda pozisyonunuz tasfiye edilmiş sayılır. Risk derecesi=(pozisyon marjı/sözleşme hesabı özkaynağı)*%100, kullanıcıların pozisyonlarını aşmasını önlemek için, sistem risk derecesinin düzeltme oranını ayarlar. Risk derecesi sistem tarafından belirlenen risk değerine ulaştığında sistem tasfiyeye zorlar. Örneğin, sistem tarafından ayarlanan düzeltme oranı %10 ise, risk dereceniz %90\'dan büyük veya eşit olduğunda, tüm pozisyonlarınız sistem tarafından zorunlu olarak kapatılır. </p> <p>Not: Sistem, aşırı risk nedeniyle tasfiyeye zorlarsa, tüm pozisyonlarınız kapatılacaktır, bu nedenle gereksiz kayıpları önlemek için riskinizi makul bir şekilde kontrol edebileceğinizi umuyorum</p>',
      part11: '<p>Ticaret türü</p> <p>Ticaret türü iki yöne ayrılır: açık uzun pozisyon (alış) ve açık kısa pozisyon (satış):</p> <p>Uzun alış (Arama) anlamına gelir mevcut endeksin yükselebileceğine inandığınız ve belirlediğiniz fiyattan veya cari piyasa fiyatından belirli miktarda sözleşme satın almayı umduğunuzu. </p> <p>Açığa satış (düşüş), mevcut endeksin düşebileceğine inandığınız ve belirli sayıda sözleşmeyi belirlediğiniz fiyattan veya mevcut piyasa fiyatından satmayı umduğunuz anlamına gelir. </p> <p>Nasıl emir verilir</p> <p>Limit emir: emrin fiyatını ve miktarını belirtmeniz gerekir</p> <p>Piyasa emri: sadece miktarı belirlemeniz gerekir Emrin, Fiyat cari piyasa fiyatıdır</p> <p>Pozisyon</p> <p>Gönderdiğiniz açılış emri tamamlandığında buna pozisyon denir</p> <p>Sözleşme teslim sorunları </p> < p>Platform sözleşmesi, belirli bir teslim süresi olmayan kalıcı bir sözleşmedir. Sistem tasfiye koşulları sağlanmadığı veya pozisyonu manuel olarak kapatmadığınız sürece pozisyonu kalıcı olarak tutabilirsiniz. </p> <p>Sistem pozisyonu kapatır</p> <p>1: Kârı durdur ve zararı durdur ayarlanan değerine ulaşıldığında sistem otomatik olarak pozisyonu kapatır</p> <p>2: Risk çok yüksekse, sistem konumu kapatmaya zorlar< /p>',
      part12: '<p>Sözleşme işleminde, kullanıcı, sözleşme fiyatına ve miktarına göre, karşılık gelen kaldıraç katına göre sözleşmenin ifası için mali teminat olarak fon ödeyerek sözleşme işlemine katılabilir ve bu fon sözleşme marjıdır. Kullanıcı, bir pozisyon açarken marjı işgal edecektir ve bir pozisyon açma marjı ne kadar fazla işgal edilirse, hesabın riski o kadar yüksek olur. </p> <p>Margin = (açılış fiyatı * miktar) / kaldıraç oranı</p>',
      part13: 'Limit emri, platforma işlem yapması için emanet etmeyi beklediğiniz fiyatı ifade eder ve piyasa emri, platformun cari fiyattan işlem yapması için doğrudan emanet etmesi anlamına gelir. Pozisyon açma kurallarında, piyasa emirleri limit emirlere göre önceliklidir. Bir limit emri seçerseniz, makul olmayan açılış fiyatlarından kaynaklanan kayıpları önlemek için lütfen mevcut para biriminin piyasa fiyatına göre makul bir pozisyon açın. ',
      part14: 'Risk seviyesi, sözleşme hesabınızdaki risk göstergesidir ve %100\'e eşit olan risk seviyesi tasfiye olarak kabul edilir. Riskiniz %50\'yi aştığında, tasfiye nedeniyle kayıp yaşamamak için dikkatli pozisyon açmanızı öneririz. Sözleşme varlıklarının mevcut fonlarını yenileyerek veya pozisyonları azaltarak riskinizi azaltabilirsiniz. ',
      part15: 'Değiş tokuşun işlevi, varlıklarınızda farklı para birimlerindeki fonların sorunsuz dolaşımını sağlamaktır ve vadeli işlem hesabında elde edilen QCC, alım satım için serbestçe USDT\'ye dönüştürülebilir. Diğer hesaplardaki USDT de işlemler için serbestçe QCC\'ye dönüştürülebilir. ',
      part16: 'Öncelikle, para transferi yaparken doldurduğunuz ödeme yönteminin, sipariş ayrıntıları sayfasında görüntülenenle tamamen aynı olduğundan emin olun. O zaman lütfen ödeme yönteminizin anında mı yoksa gecikmeli mi olduğunu onaylayın. Son olarak, sistem bakımı veya başka nedenlerle lütfen bankanız ve ödeme kurumunuzla iletişime geçin. ',
      part17: '<p>Yöntem 1: Almak veya satmak için OTC alış ve satış listesinden satın almak istediğiniz siparişi seçin. </p> <p>Yöntem 2: Hızlı işlemler için ihtiyacınıza göre alım veya satım emirlerini yayınlamak için yayınla düğmesini tıklayın. Sistem sizi hızlı bir şekilde alıcı ve satıcılarla eşleştirecektir. </p> <p>Not: Satınalma siparişinin ödemesi 15 dakika içerisinde yapılmadığı takdirde sistem siparişi otomatik olarak iptal edecektir, lütfen zamanında ödeme yapınız. Emir aynı gün içinde 3 defadan fazla iptal edilirse aynı gün içinde tekrar işlem yapılamaz ve ertesi gün alım satım yetkisi geri gelir. </p>'
    }
  }
}



// WEBPACK FOOTER //
// ./src/locales/tr.js